import { useContext, useCallback, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import useSessionStorage from '../../hooks/useSessionStorage';
import { customFetch } from '../../scripts/common/customFetch';
import FormPreview from '../../components/preview/FormPreview.js';
import CustomDialog from '../../components/ui/feedback/CustomDialog.js';
import { STORAGE_PRACTICE_OBJECT } from '../../components/common/Storage.js';
import { useTranslation } from 'react-i18next';
import * as Storage from '../../components/common/Storage.js';

const Practice = () => {
  const { learnosityRequestObj, updateLearnosityRequestObject, updatePnp } =
    useContext(AssessmentContext);
  const [searchParams] = useSearchParams();
  const { clearStorage, setStorageItem, getStorageItem, removeStorageItem } =
    useSessionStorage();
  const [loading, setIsLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogProps, setDialogProps] = useState();
  const { t } = useTranslation();
  const __practiceObject = getStorageItem(STORAGE_PRACTICE_OBJECT);
  const id = searchParams?.get('id');
  const accessCode = searchParams?.get('accessCode');

  const loginApiCall = useCallback(
    async (setErrorDialogProps, setOpenErrorDialog) => {
      clearStorage();
      setIsLoading(true);
      const { data, errorObj } = await customFetch({
        url: `${window.env.REACT_APP_PRACTICE_LOGIN_URL}?id=${id}&accessCode=${accessCode}`,
        retries: 5 //For Practice use we will retry 5 times
      });
      if (data) {
        const signedObject =
          data?.learnositySignedPayload &&
          JSON.parse(data?.learnositySignedPayload);
        if (signedObject) {
          updateLearnosityRequestObject(signedObject);
          setStorageItem(STORAGE_PRACTICE_OBJECT, { id, accessCode });
        }
        if(data?.pnp) {
          updatePnp(data.pnp);
        }
        if (data?.formInfo) {
          setStorageItem(Storage.STORAGE_FORM_INFO, data?.formInfo);
        }
        if (data?.pwaConfig) {
          setStorageItem(Storage.STORAGE_FORM_INFO, data?.pwaConfig);
        }
        setOpenErrorDialog(false);
        setErrorDialogProps();
      }
      if (errorObj) {
        clearStorage();
        setErrorDialogProps({
          title: t('components.common.accessDenied'),
          message: t('pages.practice.noPracticeAvailable'),
        });
        setOpenErrorDialog(true);
      }
      setIsLoading(false);
    },
    [
      id,
      accessCode,
      setIsLoading,
      clearStorage,
      updateLearnosityRequestObject,
      updatePnp,
      setStorageItem,
      t,
    ]
  );

  useEffect(() => {
    if (
      learnosityRequestObj &&
      id &&
      accessCode &&
      (__practiceObject?.id !== id ||
        __practiceObject?.accessCode !== accessCode)
    ) {
      updateLearnosityRequestObject();
      removeStorageItem(STORAGE_PRACTICE_OBJECT);
    }
    if (!id && !accessCode && !learnosityRequestObj) {
      setDialogProps({
        title: t('components.common.accessDenied'),
        message: t('pages.practice.invalidRequest'),
      });
      setOpenDialog(true);
    }
  }, [
    learnosityRequestObj,
    id,
    accessCode,
    __practiceObject,
    updateLearnosityRequestObject,
    removeStorageItem,
    t,
  ]);

  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CustomDialog open={openDialog} dialogProps={dialogProps} />
      <FormPreview loginApiCall={loginApiCall} />
    </>
  );
};

export default Practice;
